const optionsCarruselDown = 
    {
        margin: 20,
        responsiveClass: true,
        nav: false,
        dots: true,
        smartSpeed: 1000,
        autoplay:false,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 1,
            },
            600: {
                items: 1,
            },
            735: {
                items: 1,
            }
        },
    }

export default optionsCarruselDown;